import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {FormikSwitcher, Helper} from '@tickchak/react-share/app';
import Input from '../../../../../component/input/Input';
import LinkChainIcon from '../../../../../assets/icons/LinkChainIcon';
import SectionBox from '../SectionBox/SectionBox';
import * as css from './AdvancedTab.css';

const AdvancedTab: FC = () => {
    const {t} = useTranslation('timetable');

    return (
        <>
            <css.HelperTooltipFix />
            <SectionBox title={t('sectionVideoLink')} subtitle={t('sectionVideoLinkSubtitle')}>
                <css.fieldsTwoCols>
                    <Input
                        name="link"
                        text={t('lectureLink')}
                        icon={<LinkChainIcon />}
                        events={{maxLength: 1000}}
                        className=""
                        forwardRef={null}
                    />
                       <Input
                        name="linkName"
                        text={t('linkName')}
                        icon={<LinkChainIcon />}
                        events={{maxLength: 20}}
                        className=""
                        forwardRef={null}
                    />
                </css.fieldsTwoCols>
            </SectionBox>

            <css.mandatoryBox>
                <css.mandatoryText>
                    <css.mandatoryTitle>{t('sectionRequiredLecture')}</css.mandatoryTitle>
                    <css.mandatorySubtitle>{t('sectionRequiredLectureSubtitle')}</css.mandatorySubtitle>
                </css.mandatoryText>
                <css.mandatoryControls>
                    <FormikSwitcher
                        name="isRequired"
                        label={{on: t('toggleActive'), off: t('toggleInactive'), show: true}}
                        ariaLabel={t('sectionRequiredLecture')}
                    />
                    <Helper size="small" content={t('requiredLectureHelper')} ariaLabel={t('sectionRequiredLecture')} />
                </css.mandatoryControls>
            </css.mandatoryBox>
        </>
    );
};

export default AdvancedTab;
